import Item from "./item"

const ProductList = (props) => {
  const {
    items,
    handleRemoveItem,
    closeMiniCart,
    configurableThumbnailSource,
    storeUrlSuffix,
    updatingUids,
    onUpdateItemQuantity,
  } = props

  if (items) {
    return items.map((item) => {
      return (
        item && (
          <Item
            key={item.uid}
            item={item}
            {...item}
            closeMiniCart={closeMiniCart}
            handleRemoveItem={handleRemoveItem}
            configurableThumbnailSource={configurableThumbnailSource}
            storeUrlSuffix={storeUrlSuffix}
            isUpdatingQuantity={updatingUids.includes(item.uid)}
            onUpdateItemQuantity={(quantity) => {
              onUpdateItemQuantity(item.uid, quantity);
            }}
          />
        )
      )
    })
  }

  return null
}

export default ProductList
